export default "__VITE_ASSET__HiP7MeiK__"